import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogBody,
} from "@/components/ui/alert-dialog";
import { useEffect } from "react";
import type { ConnectedBankDto } from "@/types/tpaygate";
import { useDisconnectBank } from "@/hooks/useTPaygateQueries";

interface Props {
  bank: ConnectedBankDto | null;
  open: boolean;
  onClose: () => void;
}

export function DisconnectBankDialog({ bank, open, onClose }: Props) {
  const disconnect = useDisconnectBank();

  useEffect(() => {
    if (open) disconnect.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleConfirm = async () => {
    if (!bank) return;
    await disconnect.mutateAsync(bank.configBankId);
    onClose();
  };

  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Disconnect Bank</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogBody>
          <AlertDialogDescription>
            Are you sure you want to disconnect{" "}
            <strong>{bank?.bankName ?? bank?.bankCode}</strong> (account{" "}
            <strong>{bank?.accountNo}</strong>)?
            <br />
            <br />
            T-PayGate will revoke the VA number. Existing bills on this
            connection will no longer receive payment callbacks. This action
            cannot be undone.
          </AlertDialogDescription>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={disconnect.isPending}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {disconnect.isPending ? "Disconnecting…" : "Disconnect"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
